import { formTranslationMap } from '../../../utils/translation-map';
import  destinationTranslationMap from '../../../pages/group-travel-form/sections/product-search/data/package-destinations.json'

export const translatedFormData = (data, translationFunction) => {
  if (typeof data !== 'object' || data === null) {
    console.error('Invalid data: expected a non-null object.');
    return {};
  }

  const clonedData = structuredClone(data);

  const translateValue = (path, value) => {
    const translateItem = (item) => {
      try {
        const result = translationFunction(`${path}.${item}`);
        return result?.label ?? result ?? item;
      } catch (error) {
        console.warn(`Translation error at ${path}.${item}:`, error);
        return item;
      }
    };

    return Array.isArray(value) ? value.map(translateItem) : translateItem(value);
  };

  formTranslationMap.forEach(([path, translationPath]) => {
    try {
      const keys = path.split('.');
      const key = keys.pop();
      const parent = keys.reduce((o, k) => o?.[k], clonedData);
      if (parent && key in parent) {
        parent[key] = translateValue(translationPath, parent[key]);
      }
    } catch (error) {
      console.error(`Error processing path ${path}:`, error);
    }
  });

  try {
    const marketLang = data.market
    const destinationPath = clonedData.request?.destinations;
  
    if (Array.isArray(destinationPath)) {
      const allCountries = Object.values(destinationTranslationMap).flat();
  
      const translatedDestinations = destinationPath.map((entry) => {
        const [countryKey, resortKey] = entry.split('.');
      
        for (const country of allCountries) {
          if (country?.name?.trim().toLowerCase() === countryKey?.trim().toLowerCase()) {
            if (resortKey) {
              const destination = (country.destinations || []).find(
                (d) => d.name?.trim().toLowerCase() === resortKey?.trim().toLowerCase()
              );
      
              if (destination) {
                return `${country[marketLang] || country.en || country.name}.${destination[marketLang] || destination.en || destination.name}`;
              }
      
              console.warn('Resort not found for', resortKey, 'in', country.name);
            }
      
            return country[marketLang] || country.en || country.name;
          }
        }
      
        return entry;
      });
      

  
      clonedData.request.destinations = translatedDestinations;
    }
  } catch (error) {
    console.error('Error translating destinations:', error);
  }

  

  return clonedData;
};
